/*
  ATORI homepage sections: variant chips + Klaviyo popup opener.
  Adding to cart is handled by Blum's own <ecx-featured-prd-frm> element
  (theme.js), so the cart popup, drawer, and header count update the same way
  they do on the rest of the store. The variant chips are radio inputs named
  "id" inside the product form, so the form also works without this file.
  This file only updates the button state, price, and image.
*/
(function () {
  if (window.atoriHomeLoaded) return;
  window.atoriHomeLoaded = true;

  function initBuy(root) {
    if (root.dataset.aReady) return;
    root.dataset.aReady = 'true';

    var submit = root.querySelector('[data-a-submit]');
    var label = submit && submit.querySelector('.a-btn__label');
    var product = root.closest('[data-a-product]');
    var price = product && product.querySelector('[data-a-price]');
    var chosen = product && product.querySelector('[data-a-chosen]');
    var gallery = product && product.querySelector('[data-a-gallery]');

    function select(input) {
      var available = input.dataset.available === 'true';
      if (price && input.dataset.price) price.innerHTML = input.dataset.price;
      if (chosen) chosen.textContent = input.dataset.label || '';
      if (gallery && input.dataset.mediaId) {
        gallery.querySelectorAll('[data-media-id]').forEach(function (img) {
          img.hidden = img.dataset.mediaId !== input.dataset.mediaId;
        });
      }
      if (!submit) return;
      if (available) {
        submit.removeAttribute('disabled');
        submit.removeAttribute('aria-disabled');
        if (label) label.textContent = submit.dataset.labelAdd;
      } else {
        submit.setAttribute('disabled', '');
        if (label) label.textContent = submit.dataset.labelSoldout;
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-a-variant]')) select(e.target);
    });

    var preset = root.querySelector('[data-a-variant]:checked');
    if (preset) select(preset);
  }

  function initKlaviyo(box) {
    if (box.dataset.aReady) return;
    box.dataset.aReady = 'true';
    var form = box.querySelector('[data-a-klaviyo]');
    var fallback = box.querySelector('[data-a-fallback]');
    var opener = box.querySelector('[data-a-klaviyo-open]');

    // Opens the existing Klaviyo popup form instead of a second signup form.
    // If Klaviyo isn't loaded, or doesn't show the popup (for example the
    // shopper already closed it this visit), go to the link instead.
    if (opener) {
      opener.addEventListener('click', function (e) {
        if (!window._klOnsite) return;
        e.preventDefault();
        window._klOnsite.push(['openForm', opener.dataset.aKlaviyoOpen]);
        setTimeout(function () {
          var shown = Array.prototype.some.call(
            document.querySelectorAll('[aria-label="POPUP Form"], [aria-label="FLYOUT Form"]'),
            function (el) { return el.getClientRects().length > 0; }
          );
          var href = opener.getAttribute('href');
          if (!shown && href && href.charAt(0) !== '#') window.location.href = href;
        }, 1200);
      });
    }

    if (!form || !fallback) return;
    // If an embedded form hasn't rendered after 6s, show the signup link.
    setTimeout(function () {
      if (!form.children.length) fallback.hidden = false;
    }, 6000);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-a-buy]').forEach(initBuy);
    (scope || document).querySelectorAll('[data-a-signup]').forEach(initKlaviyo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
